import React, { useState, useRef, useEffect } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

const VideoComponent = ({ videoSrc, directLink, onVideoWatched }) => {
  const [videoDuration, setVideoDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  
  const handleTimeUpdate = (e) => {
    const current = e.target.currentTime;
    setCurrentTime(current);

    if (current >= videoDuration * 0.95) { // Consider watched when 95% completed
      onVideoWatched(true);
    } else {
      onVideoWatched(false);
    }
  };

  const handleLoadedMetadata = (e) => {
    setVideoDuration(e.target.duration);
  };

  const preventSeeking = (e) => {
    const attemptedTime = e.target.currentTime;
    if (attemptedTime > currentTime + 1) { // Prevent skipping ahead
      e.target.currentTime = currentTime;
    }
  };

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoError = () => {
    console.error("Video playback error");
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <video
        ref={videoRef}
        src={videoSrc}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onSeeking={preventSeeking}
        onError={handleVideoError}
        loop={false}
        style={{ width: "100%", height: "100%" }}
        controls={false}
        controlsList="nodownload"
      >
        Your browser does not support the video tag.
      </video>

      {/* Custom Play/Pause Button */}
      <button
        onClick={togglePlayPause}
        style={{
          position: "absolute",
          bottom: "5%",
          left: "5%",
          backgroundColor: "rgba(77, 77, 77, 0.56)",
          color: "#fff",
          border: "none",
          padding: "10px 20px",
          borderRadius: "8px",
          cursor: "pointer",
          zIndex: 11,
        }}
      >
        {isPlaying ? "Pause" : "Play"}
      </button>
    </div>
  );
};

export default VideoComponent; 